<!--<template>
  <div>

    stari progress bar...diskretniji, uzrokuje trzaje elemenata dok se pali
    <v-progress-linear :active="loading"
                       :color="color"
                       :indeterminate="true"
                       class="ma-0"
                       height="5"
                       style="top: -2px;"
                       striped>
    </v-progress-linear>
    <span v-if="loading">{{ $t('common.progress_bar_text') }}</span>
  </div>
</template>-->


<template>
  <div class="text-center">
    <v-dialog v-model="loading"
              hide-overlay
              persistent
              width="300"
              class="">
      <v-card :color="color">
        <v-card-text class="white--text loader-position">
          {{ $t('common.progress_bar_text') }}
          <v-progress-linear indeterminate
                             color="white"
                             class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      loading: Boolean,
      color: String,
    },
  };
</script>


<style>
  .loader-position * {
    /*align-items: flex-start;*/
    
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Common/Components/MyToolbarProgressBar.vue